var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { SkeletonLoader } from '@ally/metronome-ui';
var SkeletonWrapper = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var space = _a.theme.space;
    return "\n    *,\n    ::before,\n    ::after {\n      margin: 0;\n      box-sizing: border-box;\n    }\n\n    && {\n      width: 100%;\n      max-width: 1192px;\n      margin: ".concat(space.xs, " auto;\n      padding: 0 ").concat(space.xs, ";\n    }\n  ");
});
export var RouteSkeleton = function () { return (React.createElement(SkeletonWrapper, null,
    React.createElement(SkeletonLoader.Container, { "data-testid": "route-skeleton" },
        React.createElement(SkeletonLoader.Row, { height: "xl", width: "xl" }),
        React.createElement(SkeletonLoader.Row, { height: "xl", width: "xl" })))); };
var templateObject_1;
//# sourceMappingURL=RouteSkeleton.js.map